import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

import Vant from 'vant'
import 'vant/lib/index.css'

import '@/assets/styles/common.css'
// import '@/assets/styles/font.css'

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
  .use(router)
  .use(Vant)
  .mount('#appContent')
